import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {ENTER, COMMA} from '@angular/cdk/keycodes';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {EmailModel} from './email-dialog.model';
import {TypesService} from '../services/types.service';
import {ClientService} from '../services/client.service';
import {HistoryService} from '../services/history.service';
import * as _ from 'lodash';
import {Observable} from 'rxjs';
import {CommunicationsService} from '../services/communications.service';
import { FormBuilderService } from '../services/form-builder.service';
import {AngularEditorConfig, AngularEditorModule} from '@kolkov/angular-editor';
import {NgFor, NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FmcLibraryNotificationService} from '../services/notification.service';
import * as handlebars from 'handlebars';

@Component({
  selector: 'fmc-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    AngularEditorModule
  ]
})
export class EmailDialogComponent implements OnInit, OnChanges {
  @Input() recipients: any = null;
  @Input() appId: number;
  @Input() entityType: string;
  @Input() activeLook = '';
  @Input() public userPartyRoleId: any;
  @Input() public userPartyId: any;
  @Input() public emailEnabled: boolean;
  @Input() public templates: any;
  @Input() public model: any;
  @Output() public closeDialog = new EventEmitter<any>();

  public defaultControl = new EmailModel().emailForm;
  public defaultControlType = 'FormGroup';
  public email: any;
  public selectedTemplate: any;
  public emailTags: any = [];
  public globalTemplates: any = [];
  public myTemplates: any = [];
  public traxEmailTemplates: any = [];
  public filteredGlobalTemplates: any = [];
  public filteredMyTemplates: any = [];
  public formGroup: UntypedFormGroup;
  public templateLoading = false;

  // the below relates to the chip list
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public separatorKeysCodes = [ENTER, COMMA];
  public emailList = [];
  public attachments: any = [];
  public templateTags: any;
  public types: any = [
    'template-tags'
  ];

  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '500px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };

  constructor(public typesService: TypesService,
              public clientService: ClientService,
              public communicationsService: CommunicationsService,
              public notificationService: FmcLibraryNotificationService,
              public formBuilderService: FormBuilderService,
              public historyService: HistoryService) {
    this.formGroup = this.defaultControl;
    this.email = {
      'selectedTag': '',
      'selectedTemplate': '',
      'subject': '',
      'body': '',
      'recipients': []
    };
  }

  ngOnInit() {
    this.getRecipientsEmail();

    this.getTypes().subscribe(() => {
      if (this.templates && this.activeLook === 'trax') {
        this.setupTraxEmailTemplates();
      } else {
        this.setupEmailTemplates();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges', changes);
    if (changes && changes.recipients && !changes.recipients.currentValue) {
      this.formGroup.reset();
      this.emailList = [];
    } else if (changes && changes.recipients && changes.recipients.currentValue !== changes.recipients.previousValue && !changes.recipients.firstChange) {
      this.emailList = [];
      this.getRecipientsEmail();
    }
  }

  getRecipientsEmail() {
    if (this.recipients && this.recipients.length > 0) {
      this.recipients.forEach((recipient: any) => {
        const partyId = (recipient.PartyID) ? recipient.PartyID : (recipient.party.party) ? recipient.party.party.iD : recipient.party.iD;

        this.clientService.getPartyEmailAddresses(partyId)
          .subscribe(data => {
            this.pushEmailAddress(recipient, data);
          });
      });
    }
  }

  updateTemplateAttachmentFile(file: File, index: number) {
    const reader: any = new FileReader();
    reader.onload = (e) => {
      const attachment = {
        'index': index,
        'name': file.name,
        'data': reader.result.split(',')[1],
        'b64': reader.result.split(',')[1]
      };
      this.attachments.push(attachment);
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
    const readerResult = reader.readAsDataURL(file);
  }

  openFileBrowser(event) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('attachment') as HTMLElement;
    element.click();
  }

  onFileChange(event: any) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.updateTemplateAttachmentFile(files[i], i);
      // this.attachments.push(files[i]);
    }
  }

  removeAttachment(attachment): void {
    const index = this.attachments.indexOf(attachment);

    if (index >= 0) {
      this.attachments.splice(index, 1);
    }
  }

  public pushEmailAddress(recipient, data) {
    data.forEach( email => {
      if (!this.emailList.find(x => x.emailAddress === email.EmailAddress.emailAddress)) {
        this.emailList.push({emailAddress: email.EmailAddress.emailAddress});
        console.log(recipient);
        this.email.recipients.push({
          'partyId': (recipient.party && recipient.party.iD) ? recipient.party.iD : recipient.PartyID,
          'literal': {
            'emailAddress': email.EmailAddress.emailAddress,
            'displayName': (recipient.party && recipient.party.name) ? recipient.party.name : recipient.PartyName
          }
        });
      }
    });
  }

  setupTraxEmailTemplates() {
    // disable the tag field validation
    this.formGroup.get('tag').clearValidators();
    this.formGroup.get('tag').updateValueAndValidity();

    this.templates.forEach((template: any) => {
      this.clientService.getEmailTemplateById(template.templateId)
        .subscribe((result: any) => {
          this.traxEmailTemplates.push(result);
        });
    });
  }

  public setupEmailTemplates() {
    this.clientService.getEmailTemplateTags()
      .subscribe((tags: any) => {
          tags.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
          this.emailTags = tags;
        },
        error => {
          console.log(error);
        });

    // if (this.activeLook === 'calls' || this.activeLook === 'loan') {
    //   this.emailTags = this.templateTags;
    // } else {
    //   // get email template tags
    //   this.clientService.getEmailTemplateTags()
    //     .subscribe((tags: any) => {
    //         this.emailTags = tags;
    //       },
    //       error => {
    //         console.log(error);
    //       });
    // }
  }

  addEmailAddress(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.emailList.push({emailAddress: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeEmailAddress(emailAddress: any): void {
    const index = this.emailList.indexOf(emailAddress);

    if (index >= 0) {
      this.emailList.splice(index, 1);
    }

    const emailFound = this.email.recipients.findIndex( el => el.literal.emailAddress === emailAddress.emailAddress);
    if (emailFound >= 0) {
      this.email.recipients.splice(emailFound, 1);
    }
  }

  public selectEmailTag(value) {
    this.email.selectedTag = value;

    if (value === 'freehand') {
      const template = this.globalTemplates.filter(x => x.name === 'Freehand');
      this.email.selectedTemplate = template[0];
      this.formGroup.get('subject').patchValue('');
      this.formGroup.get('body').patchValue('');
    }

    this.templateLoading = true;
    this.clientService.getEmailTemplatesByTag(1000, 0, value).subscribe((templates) => {
      templates.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      this.filteredGlobalTemplates = templates;
      this.templateLoading = false;
    });
  }

  public selectEmailTemplate(value) {
    console.log(value);
    this.selectedTemplate = value;
    this.email.selectedTemplate = value;
    this.formGroup.get('subject').patchValue(value.subject);
    let emailBody = value.body;
    if (this.model) {
      const template = Handlebars.compile(emailBody);
      emailBody = template(this.model);
    }
    this.formGroup.get('body').patchValue(emailBody);
  }

  public closeDialogAction() {
    this.closeDialog.emit(true);
  }

  submitEmail(data) {
    let emailData = [];
    console.log('form submission ', data);
    console.log('Form Valid?', this.formGroup.valid);
    console.log('Email recipients', this.email);

    if (this.formGroup.valid) {
      let from;
      if (this.email.selectedTemplate.from) {
        from = this.email.selectedTemplate.from;
      } else {
        from = {
          'literal': {
            'emailAddress': 'vx@firstmac.com.au',
            'displayName': 'Vx'
          }
        };
      }

      const recipientPartyIds = [];

      //For Hive, this.email.recipients is empty since no party ID supplied. Create recipients from emailList instead.
      if (_.isEmpty(this.email.recipients)) {
        this.emailList.forEach(recipient => {
          this.email.recipients.push({
            partyId: '',
            literal: {
              emailAddress: recipient.emailAddress,
              displayName: ''
            }
          });
        });
      }

      this.email.recipients.forEach( recipient => {
        recipientPartyIds.push({
          partyId: recipient.partyId
        });

        if (this.email.selectedTag === 'freehand') {
          emailData.push({
            template: {
              id: this.email.selectedTemplate._id,
              jsonModel: {},
              partyId: recipient.partyId,
              override: {
                subject: data.subject,
                body: data.body,
                from: from,
                bcc: [{
                  partyId: recipient.partyId,
                  literal: {
                    emailAddress: recipient.literal.emailAddress,
                    displayName: recipient.literal.displayName
                  }
                }],
                to: []
              },
              recepientPartyIds: recipientPartyIds
            }
          });
        } else {
          emailData.push({
            template: {
              id: this.email.selectedTemplate._id,
              jsonModel: {},
              partyId: recipient.partyId,
              override: {
                subject: data.subject,
                body: data.body,
                from: from,
                bcc: [{
                  partyId: recipient.partyId,
                  literal: {
                    emailAddress: recipient.literal.emailAddress,
                    displayName: recipient.literal.displayName
                  }
                }],
                to: []
              }
            },
            recepientPartyIds: recipientPartyIds
          });
        }
      });

      if (this.attachments.length > 0) {
        console.log('uploading attachments for sending');
        emailData[0].template.override.attachments = this.attachments;
      }

      console.log('email data', emailData);

      this.communicationsService.sendEmail(emailData)
        .subscribe(
          status => {
            this.notificationService.notify('success', 'This email has been sent', 'Success');
            if (status) {
              this.formGroup.reset();
              this.attachments = [];
            }
            this.saveEmailHistory(emailData, recipientPartyIds);
            this.closeDialog.emit('email sent');
          },
          error => {
            console.log(error);
          });
    } else {
      this.formBuilderService.validateAllFormFields(this.formGroup);
      this.notificationService.notify('error', 'This email contains validation errors. Please ensure you have a message to the body of your email', 'Error');
      console.log('form is invalid');
      console.log(this.formGroup);
    }
  }

  saveEmailHistory(data, recipientPartyIds) {
    const body: any = {};
    body.__t = 'email';
    body.category = 'general';
    body.templateId = data[0].template.id;
    body.subject = data[0].template.override.subject;
    body.isHtml = true;
    body.body = data[0].template.override.body;
    body.from = data[0].template.override.from.literal.emailAddress;
    body.to = [];

    data.forEach( email => {
      email.template.override.bcc.forEach((to: any) => {
        body.to.push(to.literal.emailAddress);
      })
    });

    // save copy to history
    if (this.appId) {
      this.historyService.createHistoryNote(this.entityType, this.appId, body)
        .subscribe(
          result => {
            console.log(result);
          },
          error => {
            console.log(error);
          });
    }

    data.forEach((email: any) => {
      this.historyService.createHistoryNote('crumbs-party', email.template.partyId, body)
        .subscribe(
          result => {
            console.log(result);
          },
          error => {
            console.log(error);
          });
    });
  }

  public getTypes(): Observable<any> {
    return new Observable(observer => {
      this.typesService.getTypes(this.types).subscribe(
        lists => {
          lists.forEach((list, index) => {
            this[_.camelCase(this.types[index])] = list;
          });
          observer.next(null);
          observer.complete();
        },
        error => {
          console.log(error);
          observer.error(error);
        });
    });
  }
}
